const actionsBrokers = () => {
    const dataBrokers = JSON.parse(document.querySelector('[data-how-to-buy]').dataset.howToBuy);
    const howToBuyBrokersContainer = document.getElementById('how-to-buy-brokers');
    const selectBrokersCountry = document.querySelector('.custom-select-js');
    const listOption = selectBrokersCountry.querySelector('.select-options');
    const dataSelectCountryElement = selectBrokersCountry.querySelector('[data-selected-option-value]');
    const dataSelectedCountry = dataSelectCountryElement.dataset.selectedOptionValue;

    const brokerItem = (name, logo, homepage_url, checked = '') => {
        return `
      <li class="card">
        <i class="my-icon my-external"></i>
        <a href="${homepage_url}" target="_blank">
          <img src="${logo}" alt="${name}">
        </a>
      </li>
    `;
    };

    const renderBrokers = (selectedValue) => {
        const valueCountry = () => {
            if (selectedValue === 'other' || selectedValue === 'us' || selectedValue === 'ca') {
                return 'ie';
            } else {
                return selectedValue;
            }
        };

        const currentSelectedCountryBrokers = dataBrokers[valueCountry()];

        const compareBrokers = (a, b) => {
            const aOrder = parseInt(a.order);
            const bOrder = parseInt(b.order);

            if (aOrder < bOrder) return -1;
            if (aOrder > bOrder) return 1;

            return a.name.localeCompare(b.name);
        }
        const sortCurrentSelectedCountryBrokers = currentSelectedCountryBrokers.sort(compareBrokers);

        sortCurrentSelectedCountryBrokers.forEach((country, index) => {
            howToBuyBrokersContainer.insertAdjacentHTML('beforeend', brokerItem(country.name, country.img.framed.light, country.homepage_url, index === 0 ? 'checked' : ''));
        })

    };

    renderBrokers(dataSelectedCountry);

    const checkChangedAttributes = function (mutationsList, observer) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-selected-option-value') {
                const newValue = mutation.target.dataset.selectedOptionValue;

                updateBrokerList(newValue);
            }
        }
    };

    // следим за изменениями атрибута в кастомоном селекте
    const observer = new MutationObserver(checkChangedAttributes);
    observer.observe(dataSelectCountryElement, { attributes: true });

    const updateBrokerList = (selectedValue) => {
        howToBuyBrokersContainer.textContent = '';

        const uk_priv_trigger = selectedValue !== 'gb';
        if (uk_priv_trigger) $('#ukPrivateModalExchanges').modal('show');

        renderBrokers(selectedValue);
    };
}

document.addEventListener('DOMContentLoaded', () => {
    const select = new CustomSelect('.custom-select-js');
    actionsBrokers();
})